import Head from 'next/head';

import { getServerSidePropsStatusWrapper } from '@kc-console/guard';

import type { NextPageWithLayout } from '@/application/types';

import { ServicesTemplate } from '@/pages/services/ui';
import { getServiceConstants } from '@/shared/config/routes';

const ServicesPage: NextPageWithLayout = () => {
  const { SERVICE_TITLE } = getServiceConstants();
  return (
    <>
      <Head>
        <title>{SERVICE_TITLE}</title>
      </Head>
      <ServicesTemplate />
    </>
  );
};

export default ServicesPage;

export const getServerSideProps = getServerSidePropsStatusWrapper();
